<template>
  <div id="app">
    <router-view />
    <whats-app-chat />
  </div>
</template>

<script>
import WhatsAppChat from "@/components/WhatsAppChat";
export default {
  name: "App",
  components: {
    WhatsAppChat
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.notices.has-custom-container {
  position: fixed !important;
}
</style>
